import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdatePasswordRequest } from '../models/account-centre/update-password-request.model';
import { UpdatePasswordResponse } from '../models/account-centre/update-password-response.model';
import { GenericService } from '../services/generic.service';
import { UpdateUserProfileRequest } from '../models/account-centre/updateUserProfileRequest';
import { UpdateUserProfileAndCoverPhotoRequest } from '../models/account-centre/updateUserProfileAndCoverPhotoRequest';
import { UserProfileAndCoverPhotoResponse } from '../models/account-centre/userProfileAndCoverPhotoResponse';

@Injectable({
  providedIn: 'root'
})
export class AccountCentreService {
  constructor(private genericService: GenericService) {}

  updatePassword(request: UpdatePasswordRequest): Observable<UpdatePasswordResponse> 
  {
    return this.genericService.patch<UpdatePasswordResponse>('user/updatepassword', request);
  }
  updateBasicInfo(request: UpdateUserProfileRequest): Observable<UpdatePasswordResponse> 
  {
    return this.genericService.put('user/updateprofile', request);
  }

  /** Phase 0: common fields on `Person` (PUT /api/person). */
  updateMyPerson(body: Record<string, unknown>): Observable<unknown> {
    return this.genericService.put('person', body);
  }

  /** Phase 0: student extension table (PUT /api/student/profile). */
  updateMyStudentProfile(body: Record<string, unknown>): Observable<unknown> {
    return this.genericService.put('student/profile', body);
  }
  updatePhoto(request: UpdateUserProfileAndCoverPhotoRequest): Observable<UserProfileAndCoverPhotoResponse>
  {
    const formData = new FormData();
    if (request.profilePhoto) {
      formData.append('profilePhoto', request.profilePhoto);
    }
    if (request.coverPhoto) {
      formData.append('coverPhoto', request.coverPhoto);
    }
    return this.genericService.put(`user/updateprofileandcoverphoto`,formData)
  }
}
